<template>
    <header class="inner-page__header  inner-page__header-light">

        <div class="row  justify-content-between  align-items-center">

            <div class="inner-page__logo  col">
                <div class="exam__sidebar-logo">
                    <LogoComponent />
                </div>
            </div>
            <div class="inner-page__right">
                <div class="inner-page__lang test-language">
                    <button class="language-button test-language-button btn btn-sm" aria-expanded="false">
                        <span class="lang-sm lang-lbl" :title="$lang.app[testingLocale]" :lang="testingLocale"></span>
                    </button>
                </div>
                <div class="page-header__user-block">
                    <ul class="page-header__nav-list">
                        <li class="page-header__nav-item">
                            <a @click="logout($store.getters['candidate/getCandidatePin'])" class="page-header__nav-link" href="javascript:void(0)" title="Выйти из системы">
                                {{getTranslation('logout')}}
                            </a>
                        </li>
                    </ul>

                </div>
            </div>

        </div>
        <!-- /row -->

    </header>
</template>

<script>
    import LogoComponent from "./components/LogoComponent";
    
    export default {
        name: "Header",
        components: { LogoComponent },
    }
</script>

<style scoped>

</style>
